import SignAudit from '@/pages/messageManage/signAudit'
export default [
  {
    path: '/signAudit',
    name: 'SignAudit',
    component: SignAudit,
    meta: { name: '签名审核' }
  }
]



// WEBPACK FOOTER //
// ./src/router/messageManage/signAudit.js